/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
import { dontUpsell } from '@trello/browser';
import { TrelloEmoji } from '@trello/emoji/trello';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, Key } from '@trello/keybindings';

import { Auth } from 'app/scripts/db/Auth';
import { l } from 'app/scripts/lib/localize';
import { Util } from 'app/scripts/lib/util';
import { EmojiUploaderView } from 'app/scripts/views/internal/autocomplete/EmojiUploaderView';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/View';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PopoverEmojiCompleterTemplate } from 'app/scripts/views/templates/PopoverEmojiCompleterTemplate';
import { SelectEmojiTemplate } from 'app/scripts/views/templates/SelectEmojiTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface EmojiCompleterView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $emojiList: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _customEmoji: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _sortOverride: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any;
}

class EmojiCompleterView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'emoji';

    this.prototype.events = {
      // @ts-expect-error
      'mouseenter .js-select-emoji': 'hoverItem',
      'click .js-select-emoji': 'selectEmoji',
      keydown: 'keydownEvent',
      'keyup .js-filter-emoji': 'keyupEvent',
      'click .js-upload-emoji': 'openEmojiUploader',
    };
  }

  initialize() {
    this._customEmoji = {};

    Auth.me().loadCustomEmojis();
    this.listenTo(
      Auth.me().customEmojiList,
      'change add remove reset',
      this.updateCustomEmoji,
    );
    this.updateCustomEmoji();
  }

  render() {
    const data = {};

    if (this.options.input) {
      // @ts-expect-error TS(2339): Property 'input' does not exist on type '{}'.
      data.input = true;
    }
    if (this.options.button) {
      // @ts-expect-error TS(2339): Property 'button' does not exist on type '{}'.
      data.button = true;
    }

    // @ts-expect-error TS(2339): Property 'upsellEnabled' does not exist on type '{... Remove this comment to see the full error message
    data.upsellEnabled = !dontUpsell();
    this.$el.html(PopoverEmojiCompleterTemplate(data));

    this.$emojiList = $('.js-available-emoji', this.$el);
    if (this.options.input) {
      this.filterEmoji(this.getInput());
    }

    if (this.options.button) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      this.fillDefaultEmojiList();
    }

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keyupEvent(e: any) {
    const key = getKey(e);

    if ([Key.ArrowUp, Key.ArrowDown].includes(key)) {
      stopPropagationAndPreventDefault(e);
      Util.navMenuList(this.$emojiList, '.item', key);
      return;
    } else if ([Key.Enter, Key.Tab].includes(key)) {
      return;
    }

    const input = this.getInput();
    return this.filterEmoji(input);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keydownEvent(e: any) {
    let needle;
    if (((needle = getKey(e)), [Key.Enter, Key.Tab].includes(needle))) {
      stopPropagationAndPreventDefault(e);
      // eslint-disable-next-line @trello/enforce-variable-case
      const $item = this.$emojiList.find(
        '.item.selected:first .js-select-emoji',
      );
      if ($item.length > 0) {
        return $item.click();
      }
    }
  }

  updateCustomEmoji() {
    this._customEmoji = _.object(
      Auth.me().customEmojiList.map((e) => [e.get('name'), e.get('url')]),
    );
    return this.render();
  }

  getTextInput() {
    return $(this.options.target);
  }

  getInput() {
    if (this.options.button) {
      return $('.js-filter-emoji', this.$el).val();
    } else {
      // eslint-disable-next-line @trello/enforce-variable-case
      const $textInput = this.getTextInput();
      const word = Util.getWordFromCaret($textInput);
      return word.str.substring(1);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterEmoji(input: any) {
    this.clearEmojiList();
    if (this.fillEmojiList(input)) {
      return Util.selectMenuItem(
        this.$emojiList,
        '.item',
        this.$emojiList.find('.item').first(),
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderEmojiList(list: any) {
    for (const e of Array.from(list)) {
      const data = {
        name: e,
        image:
          // @ts-expect-error TS(2538): Type 'unknown' cannot be used as an index type.
          this._customEmoji[e] != null ? this._customEmoji[e] : TrelloEmoji[e],
      };

      this.$emojiList.append(templates.fill(SelectEmojiTemplate, data));
    }

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fillDefaultEmojiList(input: any) {
    const defaultEmoji = [
      'thumbsup',
      'smile',
      'warning',
      'sunglasses',
      'ballot_box_with_check',
      'facepalm',
    ];

    this.renderEmojiList(defaultEmoji);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fillEmojiList(input: any) {
    let validatedInput = input.replace(/\W+/g, '');

    if (input === '') {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      this.fillDefaultEmojiList();
      return false;
    } else if (/[A-Z]/.test(validatedInput) && this.options.input) {
      PopOver.hide();
      return false;
    }

    validatedInput = validatedInput.toLowerCase();

    $('.js-upload-emoji', this.$el)
      .text(l('upload emoji named', { emojiName: validatedInput }))
      .attr('data-emojiname', validatedInput);

    $('.js-no-matching-emoji-helper', this.$el).text(
      l('no matching emoji helper', { emojiName: validatedInput }),
    );

    const emojiMatches = this.getEmojiSuggestions(validatedInput).slice(0, 6);

    if (emojiMatches.length > 0) {
      $('.js-results', this.$el).removeClass('hide');
      $('.js-no-results', this.$el).addClass('hide');

      this.renderEmojiList(emojiMatches);
    } else {
      $('.js-results', this.$el).addClass('hide');
      $('.js-no-results', this.$el).removeClass('hide');
    }

    return emojiMatches.length !== 0;
  }

  clearEmojiList() {
    return this.$emojiList.empty();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getEmojiSuggestions(text: any) {
    let key;
    const regex = new RegExp(`^${Util.escapeForRegex(text)}`);

    const customMatches = (() => {
      const result = [];
      for (key in this._customEmoji) {
        if (regex.test(key)) {
          result.push(key);
        }
      }
      return result;
    })();
    const standardMatches = (() => {
      const result1 = [];
      for (key in TrelloEmoji) {
        if (regex.test(key)) {
          result1.push(key);
        }
      }
      return result1;
    })();

    // Bias the autocomplete towards popular emoji
    if (this._sortOverride == null) {
      const sortOverride = [
        'thumbsup',
        'smile',
        'warning',
        'sunglasses',
        'facepalm',
        'question',
        'thumbsdown',
        'wink',
        'smiley',
        'smile_cat',
        'bowtie',
        'heart',
        'laughing',
        'bug',
        'cry',
        'dancer',
        'dancers',
        'clap',
        'shipit',
        'white_check_mark',
        'star',
        'arrow_down',
        'point_down',
        'point_up',
        'point_left',
        'metal',
      ];

      this._sortOverride = {};
      for (let index = 0; index < sortOverride.length; index++) {
        const entry = sortOverride[index];
        this._sortOverride[entry] = index + 1;
      }
    }

    // We _.uniq because custom matches override standard matches
    return _.uniq([
      ...Array.from(customMatches),
      ...Array.from(standardMatches),
    ]).sort((a, b) => {
      const aOverride = this._sortOverride[a];
      const bOverride = this._sortOverride[b];

      if (aOverride && !bOverride) {
        return -1;
      } else if (bOverride && !aOverride) {
        return 1;
      } else if (aOverride && bOverride) {
        a = aOverride;
        b = bOverride;
      }

      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hoverItem(e: any) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $elem = $(e.target).closest('.item');
    return Util.selectMenuItem(this.$emojiList, '.item', $elem);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectEmoji(e: any) {
    stopPropagationAndPreventDefault(e);
    const emojiName = $(e.target)
      .closest('.js-select-emoji')
      .find('.emoji-name')
      .text();
    this.insertEmoji(emojiName);
    PopOver.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertEmoji(name: any) {
    let word;
    // eslint-disable-next-line @trello/enforce-variable-case
    const $textInput = this.getTextInput();
    if (this.options.input) {
      word = Util.getWordFromCaret($textInput);
    } else {
      const caretPosition = Util.getCaretPosition($textInput);
      if (caretPosition != null) {
        word = {
          start: caretPosition,
          end: caretPosition,
        };
      }
    }

    Util.insertSelection(
      $textInput,
      `:${`${name}`.trim()}: `,
      word != null ? word.start : undefined,
      word != null ? word.end : undefined,
    );

    return Analytics.sendUIEvent({
      action: 'selected',
      actionSubject: 'emoji',
      source: 'emojiCompleterInlineDialog',
      attributes: {
        emojiName: name,
      },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openEmojiUploader(e: any) {
    stopPropagationAndPreventDefault(e);

    const emojiName = $(e.target, this.$el).attr('data-emojiname');

    PopOver.pushView({
      keepEdits: true,
      view: EmojiUploaderView,
      options: {
        model: Auth.me(),
        emojiName,
        completerView: this,
        card: this.options.card,
      },
    });

    Analytics.sendUIEvent({
      action: 'opened',
      actionSubject: 'inlineDialog',
      actionSubjectId: 'customEmojiUploaderInlineDialog',
      source: 'cardDetailScreen',
    });
  }
}

EmojiCompleterView.initClass();
export { EmojiCompleterView };
